import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { AlertCircle, LogIn } from 'lucide-react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { useAuth } from '../context/AuthContext';

export default function SessionExpiredPage() {
  const navigate = useNavigate();
  const { logout } = useAuth();

  const handleSignInAgain = () => {
    logout();
    navigate('/login', { replace: true });
  };

  return (
    <div className="auth-page">
      <Navbar />
      <div className="auth-container">
        <div className="auth-card">
          <div className="auth-header">
            <AlertCircle size={28} />
            <h1>Session Expired</h1>
            <p>Your sign-in session has expired for security. Please sign in again.</p>
          </div>

          <div className="alert alert-warning">
            <AlertCircle size={16} /> Authentication expired. Please sign in again.
          </div>

          <button className="btn btn-accent btn-block" onClick={handleSignInAgain}>
            <LogIn size={16} /> Sign In Again
          </button>

          <p className="auth-footer-text">
            <Link to="/">Back to home</Link>
          </p>
        </div>
      </div>
      <Footer />
    </div>
  );
}
